@if (message) {
  <div
    [ngClass]="{
        'alert': message,
        'alert-success': message.type === 'success',
        'alert-danger': message.type === 'error',
        'd-none': message.type === 'close'
    }"
    [innerHTML]="message.text"
    [ngStyle]="{
        'overflow-wrap': 'anywhere'
    }"
    >
  </div>
}